module.exports = __webpack_public_path__ + "img/andrew.c26b4a2e.jpg";